import { StyledContent } from "./styled";
import { IChatContentProps } from "./types";

const Content = (props: IChatContentProps) => {
    const { children, ...rest } = props;

    return (
        <StyledContent {...rest}>
            {children}
        </StyledContent>
    )
}

export { Content };

